// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__26TGE","left":"InfoRow_left__1vLI9"};